/**
 * Quiet error logger — preserves the silent-degradation behavior of empty
 * catch blocks while still surfacing the underlying error to dev consoles +
 * production observability. Pass a short context tag to make traces grep-able.
 *
 * Use sparingly — only when the caller has a legitimate reason to ignore the
 * failure path (e.g. optional analytics, best-effort notifications fetch).
 */
export function logQuietError(context, err) {
  if (typeof window !== "undefined" && process.env.NODE_ENV !== "test") {
    // eslint-disable-next-line no-console
    console.error(`[${context}]`, err);
  }
}
